import React, { Component } from "react";

class ProductItemVariant extends Component {

	render() {
		const { isSelected, variant, isAll, product, noVariants } = this.props;

		return (
            <div 
                className={"selection" + (isSelected ? " selected" : "")} 
				onClick={() => this.props.variantClicked(isAll ? product : variant, isAll ? 'product' : 'variant', noVariants)}
			>
				{this.props.noVariants && isAll 
				? <div className="txt">Select Product</div>
				: <div className="txt">{isAll ? 'Any Variant' : variant.sku}</div>}
				<span className="icon-star-full" />
			</div>
		);
	}
}

export default ProductItemVariant;



// WEBPACK FOOTER //
// ./src/components/admin/products/product-search/ProductItemVariant.js